import createAccountRpcService from './accountRpcService';
import createSubscriptionRpcService from './subscriptionRpcService';
import { AxiosInstance } from 'axios';

export default function createRpcService(client: AxiosInstance) {
  return Object.assign(
    {},
    {
      account: createAccountRpcService(client),
      subscriptionRpc: createSubscriptionRpcService(client),
    }
  );
}
